import { MessageResponse } from "../../../common/types/apiTypes";
import { Options } from "../../../common/types/requestOptions";
import {
  AnnouncementResponse,
  AnnouncementPayload,
  AnnouncementItem,
} from "./types";
import type { DeleteAnnouncementPayload } from "./types";
import { commandMsg } from "../../../app/commandMsg";
import { queryMsg } from "../../../app/queryMsg";

export const getAllAnnouncements = (options: Options = {}) =>
  queryMsg<{ limit: number }, AnnouncementResponse>(
    "/messaging/qry/announcements",
    { limit: 1000 },
    options,
  );

export const getActiveAnnouncements = (options: Options = {}) =>
  queryMsg<{ limit: number }, AnnouncementResponse>(
    "/messaging/qry/activeAnnouncements",
    { limit: 1000 },
    options,
  );

export const postNewAnnouncement = (
  payload: AnnouncementPayload,
  options: Options = {},
) =>
  commandMsg<AnnouncementPayload, AnnouncementItem>(
    "/messaging/cmd/createAnnouncement",
    payload,
    options,
  );

export const postUpdateAnnouncement = (
  payload: AnnouncementItem,
  options: Options = {},
) =>
  commandMsg<AnnouncementItem, AnnouncementItem>(
    "/messaging/cmd/updateAnnouncement",
    payload,
    options,
  );

export const postDeleteAnnouncement = async (
  payload: DeleteAnnouncementPayload,
  options: Options = {},
) =>
  commandMsg<DeleteAnnouncementPayload, MessageResponse<{ id: string }>>(
    "/messaging/cmd/deleteAnnouncement",
    payload,
    options,
  );
